import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import hash from "object-hash";
import { ContentBox } from "./contentbox";
import { HeroImageCarousel } from "./heroimagecarousel";
import { Icon } from "../icon";
// styles
import { Image, IconText, StyledScrollIndicatorWrapper, StyledHeroWrapper, StyledRow, StyledContainer, DesktopCol, StyledCol, ScrollToElement, HighlightScrollIndicatorWrapper, } from "./heroimage.styles";
export function HeroImage({ items, type, navigationHeight = 0, contentBoxPosition = "top", isSeoConformCarousel, previewId, previewIdExtractor, slidingInterval = 6, renderTitle, onCarouselChange, }) {
    const [indicatorWidth, setIndicatorWidth] = useState();
    const theme = useTheme();
    const iconTextRef = useRef();
    const isTypeB = type === "b";
    const scrollToElementRef = useRef();
    useEffect(() => {
        if (iconTextRef.current) {
            setIndicatorWidth(iconTextRef.current.clientWidth);
        }
    }, [iconTextRef.current]);
    function onScrollIconClick() {
        scrollToElementRef.current.scrollIntoView({
            behavior: 'smooth',
        });
    }
    function renderWraper(children) {
        if (isTypeB) {
            return (_jsx(HeroImageCarousel, Object.assign({ previewId: previewId, previewIdExtractor: previewIdExtractor, items: items, slidingInterval: slidingInterval, onChange: onCarouselChange, onScrollIconClick: onScrollIconClick }, { children: children })));
        }
        return children;
    }
    return (_jsxs(_Fragment, { children: [_jsx(StyledHeroWrapper, Object.assign({ "data-preview-id": previewId, navigationHeight: navigationHeight, heroType: type }, { children: renderWraper(items.map((item, index) => {
                    const { scrollIndicatorText, image, button, color, emphasize, title, subtitle, boxposition, } = item;
                    return (_jsxs(Image, Object.assign({ "data-preview-id": typeof previewIdExtractor === "function"
                            ? previewIdExtractor({
                                scrollIndicatorText,
                                image,
                                button,
                                color,
                                emphasize,
                                title,
                                subtitle,
                            }, index)
                            : undefined, title: image.title, src: image.src, role: "img", "aria-label": image.alt }, { children: [_jsx(StyledContainer, { children: _jsxs(StyledRow, { children: [isTypeB && _jsx(DesktopCol, { size: [0, 1, 1] }), _jsx(StyledCol, { children: _jsx(ContentBox, { button: button, emphasize: emphasize, title: title, subtitle: subtitle, color: color, isTypeB: isTypeB, position: boxposition || contentBoxPosition, index: index, isSeoConformCarousel: isSeoConformCarousel, customTitle: typeof renderTitle === "function"
                                                    ? renderTitle(item)
                                                    : undefined }) })] }) }), !isTypeB && (_jsx(StyledScrollIndicatorWrapper, Object.assign({ animation: true }, { children: _jsxs(HighlightScrollIndicatorWrapper, Object.assign({ color: color, onClick: onScrollIconClick }, { children: [scrollIndicatorText && (_jsx(IconText, Object.assign({ ref: iconTextRef, color: color, animation: true, alignment: indicatorWidth > 72 ? "flex-end" : "center" }, { children: scrollIndicatorText }))), _jsx(Icon, { symbol: "double_chevron_down", color: color === "white" ? theme.colors.black : theme.colors.white })] })) })))] }), hash(image)));
                })) })), _jsx(ScrollToElement, { navigationHeight: navigationHeight, ref: scrollToElementRef })] }));
}
